module.exports = __webpack_public_path__ + "img/设备报警.5e18c08a.png";